"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showObjectInterpreter = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@morphic-ts/common/lib/utils");
var Show_1 = require("fp-ts/Show");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var asPartialShow = function (x) { return x; };
var showOrUndefined = function (s) { return ({
    show: function (x) { return (x === undefined ? 'undefined' : s.show(x)); }
}); };
/**
 *  @since 0.0.1
 */
exports.showObjectInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.ShowURI,
    interface: function (props, _name, config) { return function (env) {
        var shows = utils_1.projectFieldWithEnv(props, env)('show');
        return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.getStructShow(shows), env, { shows: shows }));
    }; },
    partial: function (props, _name, config) { return function (env) {
        var shows = utils_1.mapRecord(utils_1.projectFieldWithEnv(props, env)('show'), showOrUndefined);
        return new hkt_1.ShowType(config_1.showApplyConfig(config)(asPartialShow(Show_1.getStructShow(shows)), env, { shows: shows }));
    }; },
    both: function (props, pprops, _name, config) { return function (env) {
        var shows = utils_1.projectFieldWithEnv(props, env)('show');
        var showsPartial = utils_1.mapRecord(utils_1.projectFieldWithEnv(pprops, env)('show'), showOrUndefined);
        return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.getStructShow(tslib_1.__assign(tslib_1.__assign({}, shows), showsPartial)), env, { shows: shows, showsPartial: showsPartial }));
    }; }
}); });
